document.addEventListener('DOMContentLoaded', function () {
    const language = (document.documentElement.lang || 'pl').slice(0, 2).toLowerCase();
    const i18nLabels = {
        pl: {
            prev: 'Poprzedni slajd',
            next: 'Następny slajd',
            first: 'Przejdź do pierwszego slajdu',
            last: 'Przejdź do ostatniego slajdu',
            slideX: 'Przejdź do slajdu %s',
            pageX: 'Przejdź do strony %s',
            play: 'Uruchom autoplay',
            pause: 'Zatrzymaj autoplay',
            carousel: 'Karuzela',
            slide: 'Slajd',
            select: 'Wybierz slajd do pokazania',
            slideLabel: '%s z %s',
        },
        en: {
            prev: 'Previous slide',
            next: 'Next slide',
            first: 'Go to first slide',
            last: 'Go to last slide',
            slideX: 'Go to slide %s',
            pageX: 'Go to page %s',
            play: 'Start autoplay',
            pause: 'Pause autoplay',
            carousel: 'Carousel',
            slide: 'Slide',
            select: 'Select a slide to show',
            slideLabel: '%s of %s',
        },
        de: {
            prev: 'Vorherige Folie',
            next: 'Nächste Folie',
            first: 'Zur ersten Folie',
            last: 'Zur letzten Folie',
            slideX: 'Zu Folie %s',
            pageX: 'Zu Seite %s',
            play: 'Autoplay starten',
            pause: 'Autoplay pausieren',
            carousel: 'Karussell',
            slide: 'Folie',
            select: 'Folie auswählen',
            slideLabel: '%s von %s',
        },
        fr: {
            prev: 'Diapositive précédente',
            next: 'Diapositive suivante',
            first: 'Aller à la première diapositive',
            last: 'Aller à la dernière diapositive',
            slideX: 'Aller à la diapositive %s',
            pageX: 'Aller à la page %s',
            play: 'Lancer la lecture automatique',
            pause: 'Mettre en pause la lecture automatique',
            carousel: 'Carrousel',
            slide: 'Diapositive',
            select: 'Sélectionner une diapositive',
            slideLabel: '%s sur %s',
        },
        it: {
            prev: 'Slide precedente',
            next: 'Slide successiva',
            first: 'Vai alla prima slide',
            last: "Vai all'ultima slide",
            slideX: 'Vai alla slide %s',
            pageX: 'Vai alla pagina %s',
            play: 'Avvia autoplay',
            pause: 'Metti in pausa autoplay',
            carousel: 'Carosello',
            slide: 'Slide',
            select: 'Seleziona una slide',
            slideLabel: '%s di %s',
        },
        cs: {
            prev: 'Předchozí snímek',
            next: 'Další snímek',
            first: 'Přejít na první snímek',
            last: 'Přejít na poslední snímek',
            slideX: 'Přejít na snímek %s',
            pageX: 'Přejít na stránku %s',
            play: 'Spustit autoplay',
            pause: 'Pozastavit autoplay',
            carousel: 'Karusel',
            slide: 'Snímek',
            select: 'Vyberte snímek',
            slideLabel: '%s z %s',
        },
        sk: {
            prev: 'Predchádzajúci slajd',
            next: 'Ďalší slajd',
            first: 'Prejsť na prvý slajd',
            last: 'Prejsť na posledný slajd',
            slideX: 'Prejsť na slajd %s',
            pageX: 'Prejsť na stránku %s',
            play: 'Spustiť autoplay',
            pause: 'Pozastaviť autoplay',
            carousel: 'Karusel',
            slide: 'Slajd',
            select: 'Vyberte slajd',
            slideLabel: '%s z %s',
        },
    };
    const i18n = i18nLabels[language] || i18nLabels.pl;

    const baseOptions = {
        type: 'loop',
        perMove: 1,
        arrows: true,
        speed: 1000,
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
        pauseOnHover: false,
        pagination: true,
        i18n,
        waitForTransition: false,
        flickMaxPages: 1,
        flickPower: 120,
        drag: true,
        snap: true,
    };

    const mobilePeekOptions = {
        perPage: 1,
        perMove: 1,
        focus: 0,
        trimSpace: false,
        padding: {
            right: '34%',
        },
    };

    const enhancePagination = (el) => {
        const pagination = el.querySelector('.splide__pagination');

        if (!pagination) {
            return;
        }

        pagination.setAttribute('aria-label', i18n.select);

        Array.from(pagination.children).forEach((child) => {
            if (child.tagName.toLowerCase() !== 'button') {
                return;
            }

            const item = document.createElement('li');
            item.className = 'splide__pagination__item';
            pagination.insertBefore(item, child);
            item.appendChild(child);
        });

        pagination.querySelectorAll('button').forEach((button, index) => {
            button.type = 'button';

            if (!button.getAttribute('aria-label')) {
                button.setAttribute('aria-label', i18n.slideX.replace('%s', index + 1));
            }
        });
    };

    const mountSplide = (splide, el) => {
        splide.on('mounted pagination:mounted updated moved resized', () => {
            enhancePagination(el);
        });

        splide.mount();
        enhancePagination(el);
    };

    // Pages clients splide
    document.querySelectorAll('.pages-clients-splide').forEach((el) => {
        const splide = new Splide(el, {
            ...baseOptions,
            perPage: 7,
            perMove: 1,
            focus: 0,
            clones: 14,
            trimSpace: false,
            gap: '2.5rem',
            arrows: false,
            pagination: false,
            autoplay: true,
            interval: 4000,
            pauseOnHover: false,
            breakpoints: {
                1200: {
                    perPage: 6,
                    perMove: 1,
                    focus: 0,
                    clones: 12,
                    gap: '1.75rem',
                },
                900: {
                    perPage: 4,
                    perMove: 1,
                    focus: 0,
                    clones: 8,
                },
                650: {
                    perPage: 3,
                    perMove: 1,
                    focus: 0,
                    clones: 6,
                    gap: '1.25rem',
                    padding: {
                        right: '10%',
                    },
                },
                550: {
                    perPage: 2,
                    perMove: 1,
                    focus: 0,
                    clones: 6,
                    padding: {
                        right: '18%',
                    },
                },
            },
        });

        mountSplide(splide, el);
    });

    // Pages case studies splide
    document.querySelectorAll('.pages-case-studies-splide').forEach((el) => {
        const splide = new Splide(el, {
            ...baseOptions,
            type: 'loop',
            perPage: 3,
            perMove: 1,
            trimSpace: false,
            clones: 6,
            gap: '1.25rem',
            arrows: false,
            pagination: true,
            breakpoints: {
                1200: {
                    perPage: 2,
                    perMove: 1,
                    clones: 6,
                    gap: '1rem',
                },
                767: {
                    ...mobilePeekOptions,
                    clones: 6,
                    gap: '0.75rem',
                },
                550: {
                    ...mobilePeekOptions,
                    clones: 4,
                    gap: '0.75rem',
                },
            },
        });

        mountSplide(splide, el);
    });

    // Page experts splide (mobile)
    document.querySelectorAll('.pages-experts-splide').forEach((el) => {
        const splide = new Splide(el, {
            type: 'slide',
            perMove: 1,
            arrows: false,
            pagination: true,
            speed: 500,
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
            i18n,
            waitForTransition: false,
            flickMaxPages: 1,
            flickPower: 120,
            drag: true,
            snap: true,
            gap: '1rem',
            perPage: 2,
            focus: 0,
            trimSpace: false,
            padding: {
                right: '12%',
            },
            breakpoints: {
                550: {
                    ...mobilePeekOptions,
                },
            },
        });

        mountSplide(splide, el);
    });

    // Pages media splide
    document.querySelectorAll('.pages-media-splide').forEach((el) => {
        const slidesCount = el.querySelectorAll('.splide__list > .splide__slide').length;

        if (!slidesCount) {
            return;
        }

        const splide = new Splide(el, {
            ...baseOptions,
            type: slidesCount > 1 ? 'loop' : 'slide',
            perPage: 1,
            perMove: 1,
            clones: slidesCount > 1 ? 4 : 0,
            arrows: false,
            pagination: slidesCount > 1,
            gap: 0,
            drag: slidesCount > 1,
        });

        mountSplide(splide, el);
    });
});
